import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import DangerousOutlinedIcon from '@mui/icons-material/DangerousOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import RecordVoiceOverOutlinedIcon from '@mui/icons-material/RecordVoiceOverOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';

export interface NavMenuItem {
  id?: number;
  name: string;
  path: string;
  icon: JSX.Element;
  action?: () => void;
}

export const NavMenueItems: NavMenuItem[] = [
  {
    id: 1,
    name: 'Start',
    path: '/',
    icon: <HomeOutlinedIcon />,
  },
  {
    id: 2,
    name: 'Reservierungen',
    path: '/reservierungen',
    icon: <PendingActionsOutlinedIcon />,
  },
  {
    id: 3,
    name: 'Ansprechpersonen',
    path: '/ansprechpersonen',
    icon: <QuestionAnswerOutlinedIcon />,
  },
  {
    id: 4,
    name: 'Schadensmeldungen',
    path: '/schadensmeldungen',
    icon: <DangerousOutlinedIcon />,
  },
  {
    id: 5,
    name: 'Ungelesene Dokumente',
    path: '/ungelesene-dokumente',
    icon: <EmailOutlinedIcon />,
  },
  {
    id: 6,
    name: 'Dokumente',
    path: '/dokumente',
    icon: <DescriptionOutlinedIcon />,
  },
  {
    id: 7,
    name: 'Jahresabrechnung',
    path: '/jahresabrechnung',
    icon: <InsertInvitationOutlinedIcon />,
  },
  {
    id: 8,
    name: 'Kontoauszug',
    path: '/kontoauszug',
    icon: <CalculateOutlinedIcon />,
  },
  {
    id: 10,
    name: 'Mitteilungen',
    path: '/mitteilungen',
    icon: <MessageOutlinedIcon />,
  },
  {
    id: 11,
    name: 'News',
    path: '/news',
    icon: <NewspaperIcon />,
  },
  {
    id: 12,
    name: 'Schwarzes Brett',
    path: '/schwarzes-brett',
    icon: <DashboardOutlinedIcon />,
  },
  {
    id: 13,
    name: 'Ölpreise',
    path: '/oil-prices',
    icon: <ShowChartOutlinedIcon />,
  },
  {
    id: 14,
    name: 'Sprechtage',
    path: '/sprechtage',
    icon: <RecordVoiceOverOutlinedIcon />,
  },
  {
    id: 15,
    name: 'Meine Daten',
    path: '/meine-daten',
    icon: <PersonOutlineOutlinedIcon />,
  },
  {
    id: 16,
    name: 'Haushaltsversicherung',
    path: '/haushaltsversicherung',
    icon: <HealthAndSafetyOutlinedIcon />,
  },
  {
    id: 17,
    name: 'Logout',
    path: '/login',
    icon: <LogoutOutlinedIcon />,
  },
];
